module.exports = __webpack_public_path__ + "img/category-skill-game-hover.50896620.png";